import ShopNowCards from "./ShopNowCards/ShopNowCards";
import OfferSection from "./OfferSection/OfferSection";
import ExploreCategories from "./ExploreCategories/ExploreCategories";
import WhyPrintOutMedia from "./WhyPrintOutMedia/WhyPrintOutMedia";
import ShopByNeeds from "./ShopByNeeds/ShopByNeeds";
import NewLaunches from "./NewLaunches/NewLaunches";
import LiveOffer from "./LiveOffer/LiveOffer";
import HomeBlog from "./HomeBlog/HomeBlog";
import PopularProducts from "./PopularProducts/PopularProducts";
import PartneredWith from "./PartneredWith/PartneredWith";
import LeaderPersonalization from "./LeaderPersonalization/LeaderPersonalization";
import Print_media_Name_holder from "./Print_media_Name_holder/Print_media_Name_holder";
import { getblog } from "../../features/blog/Slice";
import {
  getAllCategories,
  getAllDataSubCategory,
  getAllSubCategory,
} from "../../features/master/masterSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  getAllPopulerProduct,
  getAllProducts,
  getAllProductsNewLaunch,
} from "../../features/products/productsSlice";
import { getCoupons, getOfferProduct } from "../../features/home/homeSlice";
import Home_Category_Banner from "./Home_Category_Banner/Home_Category_Banner";
import Adv_card_section from "./Adv_card_section/Adv_card_section";
import Adv_banner from "./Adv_banner/Adv_banner";
import Something_Big_Coming from "./Something_Big_Coming/Something_Big_Coming";
import Top_Enterprises from "./Top_Enterprises/Top_Enterprises";
import At_Printout_Media from "./At_Printout_Media/At_Printout_Media";
import What_Customer_Say from "./what_customer_say/What_Customer_Say";
import Our_Blog from "./our_blog/Our_Blog";

function Home() {
  const category = useSelector((state) => state.master.categories);
  const subcategory = useSelector((state) => state.master.all_subcategories);
  const dispatch = useDispatch();

  console.log("category",category)

  useEffect(() => {
    dispatch(getAllCategories());
    dispatch(getAllDataSubCategory());
  }, [dispatch]);

  const productdata = useSelector(
    (state) => state.product.allProductsNewLaunch,
  );
  useEffect(() => {
    dispatch(
      getAllProductsNewLaunch({
        type: "new-launch",
      }),
    );
  }, [dispatch]);

  const populerProductdata = useSelector(
    (state) => state.product.allPopulerProducts,
  );
  useEffect(() => {
    dispatch(
      getAllPopulerProduct({
        type: "popular-product",
      }),
    );
  }, [dispatch]);

  const OfferProduct = useSelector((state) => state.home.all_offer_product);

  useEffect(() => {
    dispatch(getOfferProduct());
  }, [dispatch]);

  return (
    <>
      <Home_Category_Banner category={category}/>
      <Adv_card_section />
      {/* {category.length > 0 && <ShopNowCards category={category} />} */}
      {/* <OfferSection /> */}
      {category?.length > 0 && (
        <ExploreCategories subcategory={category} />
      )}

      <Adv_banner />
      <Something_Big_Coming />
      <Top_Enterprises />
      {/* <WhyPrintOutMedia /> */}
      {/* <ShopByNeeds /> */}
      {/* {productdata?.length > 0 && <NewLaunches productdata={productdata} />} */}

      {/* <HomeBlog /> */}
      {/* {populerProductdata?.length > 0 && ( */}
      <PopularProducts productdata={populerProductdata} />
      {/* )} */}

      <At_Printout_Media />

      {subcategory?.length > 0 && <LiveOffer data={OfferProduct} />}

      <What_Customer_Say />

      <Our_Blog/>


      {/* <LeaderPersonalization /> */}
      {/* <PartneredWith /> */}
    </>
  );
}

export default Home;
